export default __webpack_public_path__ + "static/media/mail.3e9e021f.svg";